import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface SmsDoc {
  id: string;
  created: number;
  role: string;
  id_api_key?: string;
  deliverability?: string;
  platform?: string;
}

interface SubscriptionRef {
  id: string;
  api_key: string;
}

/**
 * Fetch SMS documents for the current billing period for each subscription.
 */
export async function getSmsBySubscriptions(
  {
    subscriptions,
    startTimestamp,
    endTimestamp,
  }: {
    subscriptions: SubscriptionRef[],
    startTimestamp?: number,
    endTimestamp?: number,
  },
  companyApiKey: string,
  auth: Authentication,
): Promise<Record<string, SmsDoc[]>> {
  try {
    if (!subscriptions || subscriptions.length === 0 || !startTimestamp || !companyApiKey) return {};

    const subscriptionIds = subscriptions.map((s) => s.id);

    const response = await HttpClient.get(
      `/leedflow/stats/sms/by-subscriptions?subscription_ids=${encodeURIComponent(
        subscriptionIds.join(','),
      )}&start=${encodeURIComponent(String(startTimestamp))}${endTimestamp ? `&end=${encodeURIComponent(String(endTimestamp))}` : ''
      }`,
      auth.token,
      {
        'x-api-key': companyApiKey,
      },
    );

    return (response?.data ?? {}) as Record<string, SmsDoc[]>;
  } catch (e) {
    console.error('getSmsBySubscriptions error:', e);
    throw new GetSmsBySubscriptionsFailure((e as Error)?.message || 'Unknown error');
  }
}

export class GetSmsBySubscriptionsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'get-sms-by-subscriptions-failure') {
    super(message, code);
  }
}

